import Vue from 'vue'
import Router from 'vue-router'
import CommonRoutes from './routers/common.js'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      //首页
      path: '/home',
      name: 'home',
      component: resolve =>  require(['@/views/Home.vue'], resolve),
    },
    {
      // 登录页面
      path: '/login',
      name: 'login',
      component: resolve => require(['../views/Login.vue'], resolve)
    },
    {
      //厂家列表
      path: '/dms/manufacturer_list',
      name: 'manufacturer_list',
      component: resolve => require(['@/views/dms/manufacturerList.vue'], resolve)
    },
    {
      //DMS 项目使用条数明细
      path: '/dms/view_project_list',
      name: 'view_project_list',
      component: resolve => require(['@/views/dms/viewProjectList.vue'], resolve)
    },
    ...CommonRoutes
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js